import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, clientId, setAttributes } ) {
	const { blockId } = attributes;
	const uniqueId = clientId || blockId;
	const unique = uniqueId
		? `.alpha-column-blocks.alpha-column-block-${ uniqueId }`
		: '.wp-block-alphablock-column';
	const {
		border,
		padding,
		columnWidth,
		columnBackground,
		backgroundOpacity,
		alignItems,
		justifyContent,
		flexDirection,
		flexWrap,
		gap,
		maxHeight,
		overflow,
		borderRadius,
	} = attributes;

	const CssObj = {
		[ unique ]: [
			GenerateCss.css( 'flex-grow', '1' ), // Prevent column from growing
			GenerateCss.css( 'flex-shrink', '1' ), // Prevent column from shrinking
			GenerateCss.border( border ),
			GenerateCss.borderRadius( borderRadius ),
			GenerateCss.padding( padding ),
			GenerateCss.css(
				'flex-basis',
				columnWidth?.desktop?.val + '' + columnWidth?.desktop?.unit
			),
			GenerateCss.css(
				'min-width',
				columnWidth?.desktop?.val + '' + columnWidth?.desktop?.unit
			),
			GenerateCss.background( columnBackground ),
			GenerateCss.css( 'display', 'flex' ),
			GenerateCss.css( 'flex-direction', flexDirection ),
			GenerateCss.css( 'align-items', alignItems ),
			GenerateCss.css( 'justify-content', justifyContent ),
			GenerateCss.css( 'flex-wrap', flexWrap ),
			GenerateCss.css(
				'gap',
				gap?.desktop?.val + '' + gap?.desktop?.unit
			),
			GenerateCss.lengthProp( 'max-height', maxHeight ),
			GenerateCss.css( 'overflow', overflow ),
		],
		[ `${ unique }.is-empty .block-editor-inner-blocks` ]: [
			GenerateCss.css( 'width', '100%' ),
		],
		[ `${ unique }.is-empty .block-editor-button-block-appender` ]: [
			GenerateCss.css( 'width', '100%' ),
			GenerateCss.css( 'border', '1px dashed #ccc' ),
			GenerateCss.css( 'padding', '10px' ),
			GenerateCss.css( 'justify-content', 'center' ),
		],
		[ `${ unique }.is-empty .block-list-appender, ${ unique }.is-empty .block-editor-inserter, ${ unique }.is-empty ..block-editor-button-block-appender` ]:
			[
				GenerateCss.css( 'display', 'flex' ),
				GenerateCss.css( 'width', '100%' ),
				GenerateCss.css( 'height', '100%' ),
			],
	};

	console.log("columnBackground: ", columnBackground);

		const compiledCss = GenerateCss.CompiledCss( CssObj );
	
		useSyncCompiledCss( compiledCss, setAttributes );
	
		return <style block="alpha-block/column">{ compiledCss }</style>;

}

export default Style;
